import mutations from '@/store/modules/k8/k8CommonState/k8.mutations';
import actions from '@/store/modules/k8/k8CommonState/k8.actions';
import getters from '@/store/modules/k8/k8CommonState/k8.getters';
import { KeyLabel } from '@/store/mutations-typesCommon';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';
import { WorkloadList } from '@/components/K8M/k8.types';
import { Service } from '@/utils/types/global';

export interface State {
  k8Clusters: Array<Service>;
  k8Namespaces: Array<KeyLabel>;
  k8Workloads: Array<KeyLabel>;
  k8Statefulsets: Array<KeyLabel>;
  k8Daemonsets: Array<KeyLabel>;
  k8Deployments: Array<KeyLabel>;
  currentK8Tab: String;
  currentRoute: Array<any>;
  graphs: Array<any>;
  tables: Array<any>;
  currentNode: KeyLabel;
  currentDep: KeyLabel;
  currentStatefulset: KeyLabel;
  currentDaemonset: KeyLabel;
  currentPod: KeyLabel;
  currentNamespace: KeyLabel;
  currentCluster: Service;
  currentWorkload: KeyLabel;
  k8NodeEntities: Array<KeyLabel>;
}

export const initialState: State = {
  k8Clusters: [],
  k8Namespaces: [],
  k8Workloads: WorkloadList,
  k8Statefulsets: [],
  k8Daemonsets: [],
  k8Deployments: [],
  currentK8Tab: K8_NAVTABS.K8M_CLUSTER_TAB,
  currentRoute: [],
  graphs: [K8_NAVTABS.K8M_NODE_TAB],
  tables: [
    K8_NAVTABS.K8M_DAEMON_TAB,
    K8_NAVTABS.K8M_DEP_TAB,
    K8_NAVTABS.K8M_STAT_TAB,
  ],
  currentNode: { key: '', label: '' },
  currentDep: { key: 'all', label: 'all' },
  currentStatefulset: { key: 'all', label: 'all' },
  currentDaemonset: { key: 'all', label: 'all' },
  currentPod: { key: '', label: '' },
  currentNamespace: { key: 'all', label: 'All' },
  currentCluster: { key: '', label: '', permissions: [] },
  currentWorkload: WorkloadList[0],
  k8NodeEntities: [],
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};